import styled from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'
import Link from '../../Link/Link'

export const DurationOverlay = styled.div`
  margin: 0 0 5px 10px;
  display: flex;
  align-items: center;
  color: white;
  gap: 4px;
  justify-content: flex-end;
  height: 17px;
  width: 100%;

  p {
    font-size: 14px;
    font-family: ${fonts.narkis};
    font-weight: 700;
    line-height: 120%;
  }
`

export const PlayIconOverlay = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;

  svg {
    transform: scale(1.2);
  }
`

export const PlayerLinkWrapper = styled(Link)`
  align-self: flex-start;
  position: relative;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  cursor: pointer;
  pointer-events: auto;

  ${device.medium} {
    padding: 8px 16px;
  }

  a,
  &:visited {
    color: #00104a !important;
  }

  p {
    font-family: ${fonts.narkis};
    color: #00104a !important;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 21.622px;

    ${device.medium} {
      line-height: 16px;
    }
  }
`

// export const VerticalPlayerItemEpisode = styled.div`
//   color: white;
//   background: #000000;
//   font-family: ${fonts.narkis};
//   font-weight: 500;
//   font-size: 16px;
//   line-height: 120%;
//   letter-spacing: 0;
//   text-align: right;
//   margin-bottom: 6px;
//   padding: 4px;
//   flex: 0 1 auto;
//   border-radius: 4px;
//   z-index: 3;
//
//   ${device.small} {
//     font-size: 14px;
//   }
// `
export const VerticalPlayerItemEpisode = styled.div`
  color: white;
  background: #000000;
  font-family: ${fonts.narkis};
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  text-align: right;
  //margin-bottom: 6px;
  padding: 4px;
  flex: 0 1 auto;
  border-radius: 4px;
  z-index: 3;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: max-content;

  ${device.small} {
    font-size: 14px;
  }
`
